module.exports = __webpack_public_path__ + "static/img/9.33a5eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/9.png
// module id = HW1H
// module chunks = 0